import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  id: number
  username: string
  role: string
  email?: string
  createdAt?: number
  lastLogin?: number
}

interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  isLoading: boolean
  
  // Actions
  setUser: (user: User, token: string) => void
  logout: () => void
  setLoading: (loading: boolean) => void
  updateUser: (user: Partial<User>) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,

      setUser: (user: User, token: string) => {
        window.logger?.info('Setting user in store', { user, hasToken: !!token })
        set({
          user,
          token,
          isAuthenticated: true,
          isLoading: false,
        })
        window.logger?.info('User data set in store successfully')
      },

      logout: () => {
        window.logger?.info('Logging out user')
        set({
          user: null,
          token: null,
          isAuthenticated: false,
          isLoading: false,
        })
        window.logger?.info('User logged out successfully')
      },

      setLoading: (loading: boolean) => {
        set({ isLoading: loading })
      },

      updateUser: (userData: Partial<User>) => {
        const currentUser = get().user
        if (currentUser) {
          set({
            user: { ...currentUser, ...userData }
          })
        }
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
)
